import { styled } from '@mui/system';

const FlexRowCenter = styled('div')({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
});

export default FlexRowCenter;
